import {
  email,
  maxLength,
  required,
  minLength,
  helpers
} from 'vuelidate/lib/validators';
import { vuelidatePasswordValidations } from '../../utils/validations';
import { NAMES_REGEX } from 'ecx.saigon.ui.common';

const alphaWhite = helpers.regex('alphaWhite', NAMES_REGEX);

export default {
  email: {
    required,
    email,
    maxLength: maxLength(100)
  },
  firstName: {
    required,
    alphaWhite,
    maxLength: maxLength(100),
    minLength: minLength(2)
  },
  lastName: {
    required,
    alphaWhite,
    maxLength: maxLength(100),
    minLength: minLength(2)
  },
  password: { ...vuelidatePasswordValidations }
};
